import service from './system/server';

// 通用的get请求
export const commonGet = (url, params = {}) => {
  return service({
    url,
    method: 'GET',
    params
  })
}

// 通用post请求
export const commonPost = (url, data = {}) => {
  return service({
    url,
    method: 'POST',
    data
  })
}

// 携带user的Blob请求
export const fieldsGet = (url, responseType = 'blob') => {
  return service({
    url,
    method: 'get',
    responseType
  })
}

// 上传
export const fileUpload = file => {
  let formData = new FormData(); //所需参数
  formData.append("file", file.raw);
  formData.append("value", '图片上传');
  return service({
    url:`/api/file/upload`,
    method: "POST",
    data: formData,
    headers: {
      'Content-Type': 'x-www-form-urlencoded'
    }
  })
}